import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

import { AuthFacade } from '@mitsubishi/core';
import { SectionTitleComponent } from '@mitsubishi/shared/ui';

import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'apm-text-wrapper',
  templateUrl: './text-wrapper.component.html',
  styleUrls: ['./text-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SectionTitleComponent, MatTooltip],
})
export class TextWrapperComponent extends FieldWrapper {
  canDebug = inject(AuthFacade).canDebug;
}
